import React, { useState, useRef, useEffect } from "react";
import CSOnlineShoppingImage from "../../images/Fresh-Online-Shopping.jpeg";
import CSCardImage1 from "../../images/card-img-1.jpg";
import CSCardImage2 from "../../images/card-img-2.jpg";
import CSCardImage3 from "../../images/card-img-3.jpg";
import CSCardImage4 from "../../images/card-img-4.jpg";
import CSCardImage5 from "../../images/card-img-5.jpg";
import CSCardImage6 from "../../images/card-img-6.jpg";
import CSCardImage7 from "../../images/card-img-7.jpg";
import CSCardImage8 from "../../images/card-img-8.jpg";
import CSCardImage9 from "../../images/card-img-9.jpg";
import CSCardImage10 from "../../images/card-img-10.jpg";
import CSAuthorImage from "../../images/ht-logo.png";
import { motion, useViewportScroll, useTransform, useSpring } from 'framer-motion';
import LazyLoad from 'react-lazyload';


export default function CSOurProduct(props) {
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 300;
  const ref = useRef();
  const leftColImageRefs = useRef([]);
  const middleColImageRefs = useRef([]);
  const rightColImageRefs = useRef([]);

  const setValues = () => {
    setElementTop(ref.current.offsetTop);
    setElementBottom(ref.current.offsetTop + ref.current.offsetHeight);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!ref.current) return;

    props.isLoaded && setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });

  const y = useSpring(useTransform(scrollY, [elementTop - clientHeight * 1.2, elementTop - clientHeight * 0.3], [yOffset, 0], "anticipate"),
    { damping: 40, stiffness: 300 });

  const leftColImageTop = (leftColImageRefs.current[0] && leftColImageRefs.current[1]) ? [leftColImageRefs.current[0].offsetTop, leftColImageRefs.current[1].offsetTop] : [0, 0];
  const middleColImageTop = (middleColImageRefs.current[2]) ? [middleColImageRefs.current[0].offsetTop, middleColImageRefs.current[1].offsetTop, middleColImageRefs.current[2].offsetTop] : [0, 0, 0];
  const rightColImageTop = (rightColImageRefs.current[2]) ? [rightColImageRefs.current[0].offsetTop, rightColImageRefs.current[1].offsetTop, rightColImageRefs.current[2].offsetTop] : [0, 0, 0];

  const springProps = { damping: 30, stiffness: 300 };
  const easing = [0.42, 0, 0.58, 1];
  const leftColImageY0 = useSpring(useTransform(scrollY, [leftColImageTop[0] - clientHeight * 1.2, leftColImageTop[0] - clientHeight * 0.7], [120, 0], easing), springProps);
  const leftColImageY1 = useSpring(useTransform(scrollY, [leftColImageTop[1] - clientHeight * 1.2, leftColImageTop[1] - clientHeight * 0.7], [120, 0], easing), springProps);

  const middleColImageY0 = useSpring(useTransform(scrollY, [middleColImageTop[0] - clientHeight * 1.1, middleColImageTop[0] - clientHeight * 0.6], [120, 0], easing), springProps);
  const middleColImageY1 = useSpring(useTransform(scrollY, [middleColImageTop[1] - clientHeight * 1.1, middleColImageTop[1] - clientHeight * 0.6], [120, 0], easing), springProps);
  const middleColImageY2 = useSpring(useTransform(scrollY, [middleColImageTop[2] - clientHeight * 1.1, middleColImageTop[2] - clientHeight * 0.6], [120, 0], easing), springProps);

  const rightColImageY0 = useSpring(useTransform(scrollY, [rightColImageTop[0] - clientHeight * 1, rightColImageTop[0] - clientHeight * 0.7], [120, 0], easing), springProps);
  const rightColImageY1 = useSpring(useTransform(scrollY, [rightColImageTop[1] - clientHeight * 1, rightColImageTop[1] - clientHeight * 0.7], [120, 0], easing), springProps);
  const rightColImageY2 = useSpring(useTransform(scrollY, [rightColImageTop[2] - clientHeight * 1, rightColImageTop[2] - clientHeight * 0.7], [120, 0], easing), springProps);

  return (
    <div className="cs-ourproduct-section section-gap" onLoad={() => { props.isLoaded && setValues(); }}>
      <div className="section-gap">
        <div ref={ref} className="container">
          <div className="align-start d-flex flex-wrap row">
            <div className="col cs-ourProduct-content">
              <h3>A Fresh Online Shopping Experience</h3>
              <p>Digital shoppers expect companies to offer personalized products and experiences to satisfy their unique needs. The new web experience offered customers a curated selection of products and promotions based on their personal shopping behaviors. It also allowed them to browse and search the entire inventory at their nearby stores. </p>
            </div>
            <motion.div style={{ y }} className="col cs-ourProduct-image">
              <img src={CSOnlineShoppingImage} className="cb-online-shopping" title="Online Shopping Experience" alt="digital shopping experience retail" />
            </motion.div>
          </div>
        </div>
      </div>


      <div className="ebusiness-middle-section section-gap">
        <div className="container-small">
          <h3>Next-gen Content Management System</h3>
          <p>
            Harris Teeter’s website was built with legacy Microsoft tech and it was time to redesign the web shopping experience for its millions of loyal customers. As the mainstream channel, the website also included corporate profiles, marketing initiatives, community programs, and many additional services, and we had to exceed expectations for all stakeholders.</p>

          <p>Together with the HT team, we worked hard to understand various user groups’ needs and evaluated multiple options. Within 3 months, we launched a beautiful content management system and personalized storefront that received raving reviews from all stakeholders and customers.</p>
        </div>
      </div>

      <div className="three-column-image section-gap">
        <div className="container">

          <div className="row d-flex flex-wrap masonary-image-desktop">
            <div className="col left-col">
              <motion.img ref={r => leftColImageRefs.current[0] = r} style={{ y: leftColImageY0 }} src={CSCardImage1} title="Retail Experience" alt="retail experiencent" />
              <motion.img ref={r => leftColImageRefs.current[1] = r} style={{ y: leftColImageY1 }} src={CSCardImage2} title="Food Ordering System" alt="food ordering system" />
            </div>
            <div className="col middle-col">
              <div className="row d-flex flex-wrap">
                <div className="col">
                  <motion.img ref={r => middleColImageRefs.current[0] = r} style={{ y: middleColImageY0 }} src={CSCardImage3} title="Online Recipes and Food Order" alt="online recipes and food order" />
                  <motion.img ref={r => middleColImageRefs.current[1] = r} src={CSCardImage4} style={{ y: middleColImageY1 }} title="Retail Experience Development" alt="retail experience development" />
                </div>
                <div className="col">
                  <motion.img style={{ y: middleColImageY0 }} src={CSCardImage5} title="User Management" alt="user management" />
                  <motion.img src={CSCardImage6} style={{ y: middleColImageY1 }} title="Chatbots For Retail" alt="retail chatbot development" />
                </div>
              </div>
              <motion.img ref={r => middleColImageRefs.current[2] = r} style={{ y: middleColImageY2 }} src={CSCardImage7} title="online shopping portal" alt="grocery and pharmacy shopping portal" />
            </div>
            <div className="col right-col">
              <motion.img ref={r => rightColImageRefs.current[0] = r} style={{ y: rightColImageY0 }} src={CSCardImage8} title="Content Management System For Retail" alt="next-gen content management" />
              <motion.img ref={r => rightColImageRefs.current[1] = r} style={{ y: rightColImageY1 }} src={CSCardImage9} title="Grocery App Development" alt="grocery app development" />
              <motion.img ref={r => rightColImageRefs.current[2] = r} style={{ y: rightColImageY2 }} src={CSCardImage10} title="Location Tracker For Retail" alt="geolocation retail" />
            </div>
          </div>

          <div className="masonary-image-ipad">
            <LazyLoad>
              <img src={CSCardImage1} title="Retail Experience" alt="retail experiencent" />
              <img src={CSCardImage2} title="Food Ordering System" alt="food ordering system" />
              <img src={CSCardImage6} title="Chatbots For Retail" alt="retail chatbot development" />
              <img src={CSCardImage3} title="Online Recipes and Food Order" alt="online recipes and food order" />
              <img src={CSCardImage9} title="Grocery App Development" alt="grocery app development" />
              <img src={CSCardImage10} title="Location Tracker For Retail" alt="geolocation retail" />
              <img src={CSCardImage8} title="Content Management System For Retail" alt="next-gen content management" />
              <img src={CSCardImage5} title="User Management" alt="user management" />
              <img src={CSCardImage4} title="Retail Experience Development" alt="retail experience development" />
            </LazyLoad>
          </div>
        </div>
      </div>

      <div className="cs-blockquote">
        <div className="container">
          <blockquote className="blockquote-style2 text-center">
            <div className="blockquote-image"><img src={CSAuthorImage} title="Madison Palermo - Senior Manager, Product Delivery" alt="Madison Palermo" /></div>
            <h3>Rapidops’ team’s ability to understand the vision and translate it into <br /> digital products is mind-blowing.  They are smart, efficient, and  <br />knowledgeable.  They push our thinking, build high-quality <br />
                        software, and deliver the results.</h3>
            <div className="blockquote-author">
              <div className="blockquote-detail">
                <span>Senior Manager, eCommerce</span>
              </div>
            </div>
          </blockquote>
        </div>
      </div>

    </div>
  );
}